import styled from 'styled-components';

export const BadgeStyles = styled.span`
  display: inline-block;
  color: ${({ theme }) => theme.colors.primary};
  padding: 4px 8px;
  border-radius: 2px;
  font-size: ${({ theme }) => theme.fontSize.xsm};
  background: ${({ theme }) => theme.colors.weakBlue};

  &.gray {
    background: ${({ theme }) => theme.colors.color_bg};
    color: ${({ theme }) => theme.colors.color_darkgray};
  }

  &.hover {
    background: ${({ theme }) => theme.colors.color_white};
  }
`;
